import React from "react";

import { faColumns } from "@fortawesome/pro-solid-svg-icons/faColumns";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Tooltip from "antd/es/tooltip";
import { useIntl } from "react-intl";

import { EntityTypesSupportedColumnSelection } from "@mapmycustomers/shared/types/entity";
import IField from "@mapmycustomers/shared/types/fieldModel/IField";
import useBoolean from "@mapmycustomers/shared/util/hook/useBoolean";
import { Button } from "@mapmycustomers/ui";

import SelectColumnsPane, { SelectColumnsPaneProps } from "./index";

interface Props {
  columnPaneProps?: Omit<
    SelectColumnsPaneProps,
    "entityType" | "fieldFilter" | "onHide" | "visible"
  >;
  entityType: EntityTypesSupportedColumnSelection;
  fieldFilter?: (field: IField) => boolean;
}

const SelectColumnsButton: React.FC<Props> = ({ columnPaneProps, entityType, fieldFilter }) => {
  const [columnSelectorVisible, showColumnSelector, hideColumnSelector] = useBoolean();
  const intl = useIntl();

  return (
    <>
      <Tooltip
        placement="top"
        title={intl.formatMessage({
          id: "component.selectColumnsPane.button.tooltip",
          defaultMessage: "Select Columns",
          description: "Tooltip on select columns pane button",
        })}
      >
        <Button
          data-action-id="select-columns-button"
          icon={<FontAwesomeIcon icon={faColumns} />}
          iconOnly
          onClick={showColumnSelector}
          type="text"
        />
      </Tooltip>
      <SelectColumnsPane
        {...columnPaneProps}
        entityType={entityType}
        fieldFilter={fieldFilter}
        onHide={hideColumnSelector}
        visible={columnSelectorVisible}
      />
    </>
  );
};

export default SelectColumnsButton;
